import { fetchWithBodyTemplateFn } from './base/fetch-with-body-template-fn';

export const updatePartiallyTemplateFn = <
  RequestBodyType,
  RawRequestBodyType extends object,
  RawSuccessResponseType extends object,
  SuccessResponseType,
  RawErrorResponseType extends object,
  ErrorResponseType
>(
  token: string,
  uri: string,
  requestBodyConverter: (
    v: Partial<RequestBodyType>
  ) => Partial<RawRequestBodyType>,
  successResponseConverter: (v: RawSuccessResponseType) => SuccessResponseType,
  errorResponseConverter: (v: RawErrorResponseType) => ErrorResponseType
) =>
  fetchWithBodyTemplateFn('PATCH')(
    token,
    uri,
    requestBodyConverter,
    successResponseConverter,
    errorResponseConverter
  );
